import { TextField } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useEffect } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const filter = createFilterOptions();

export const FreeSoloCreateOption = ({ vesselNames, check, setSiteValue, value, setValue, handleCreateAndAssignInventory, width = '242px' }) => {

    useEffect(() => {
        setSiteValue(value)
    }, [value])

    return (
        <div>
            <Autocomplete
                disableClearable
                forcePopupIcon={true}
                value={value || ''}
                ListboxProps={{ className: 'warehouse-apply-config-props' }}
                className="audit-filter-inputs-usage config-textField association-tab-sites"
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        setValue({
                            label: newValue,
                        });
                    } else if (newValue && newValue.inputValue) {
                        setValue({
                            label: newValue.inputValue
                        });
                        check(false);
                        handleCreateAndAssignInventory(newValue.inputValue);
                    } else {
                        setValue(newValue);
                    }
                }}
                sx={{
                    width: width,
                    height: '28px',
                    '& .MuiInputBase-root': {
                        height: '28px',
                        fontSize: '13px',
                    },
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    const isExisting = options.some((option) => inputValue === option.label);
                    if (inputValue.includes("'")) {
                        check(true);
                    }
                    if (inputValue.length == 0) {
                        check(false);
                    }
                    if (inputValue !== '' && !isExisting && !inputValue.includes("'")) {
                        filtered.push({
                            inputValue,
                            label: `Add "${inputValue}"`,
                        });
                    }
                    return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                size='small'
                options={vesselNames}
                getOptionLabel={(option) => {
                    if (typeof option === 'string') {
                        return option;
                    }
                    if (option.inputValue) {
                        return option.inputValue;
                    }
                    return option.label;
                }}
                renderOption={(props, option, { index }) => (
                    <li {...props} key={`${option.label}-${index}`}>{option.label}</li>
                )}
                freeSolo
                renderInput={(params) => (
                    <TextField {...params} placeholder="select" />
                )}
                popupIcon={<ArrowDropDownIcon
                />}
            />
        </div>
    );
}